module.exports = __webpack_public_path__ + "static/media/SpartanCitizen.91e09efd.jpg";